import { _ as _slicedToArray } from './_rollupPluginBabelHelpers-f5c57928.js';
import React__default, { useState } from 'react';
import PropTypes from 'prop-types';
import Icon from './Icon.js';
import { n as nodeOrStringProp } from './PropTypes-9aad034b.js';
import './_commonjsHelpers-97e6d7b1.js';
import 'moment';

var Tabs = function Tabs(props) {
  var tabs = props.tabs,
    selectedTab = props.selectedTab,
    onTabChange = props.onTabChange,
    className = props.className;
  var _useState = useState(selectedTab),
    _useState2 = _slicedToArray(_useState, 2),
    currentTab = _useState2[0],
    setCurrentTab = _useState2[1];
  return /*#__PURE__*/React__default.createElement("div", {
    className: "bf-tabs-main-wrapper ".concat(className)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "bf-tabs-header-wrapper"
  }, tabs.map(function (tab, index) {
    var key = "TAB_HEADER_ITEM_".concat(index);
    return /*#__PURE__*/React__default.createElement("div", {
      className: "bf-tab-header-item ".concat(currentTab === index ? 'bf-tab-is-active' : ''),
      onClick: function onClick() {
        setCurrentTab(index);
        onTabChange();
      },
      key: key
    }, tab.triggerIcon ? /*#__PURE__*/React__default.createElement(Icon, {
      name: tab.titleIcon,
      className: "bf-tab-header-item-icon"
    }) : null, /*#__PURE__*/React__default.createElement("span", {
      className: "bf-tab-header-item-title"
    }, tab.title));
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "bf-tabs-content-wrapper"
  }, tabs.map(function (tab, index) {
    var key = "TAB_CONTENT_".concat(index);
    return index === currentTab ? /*#__PURE__*/React__default.createElement("div", {
      key: key
    }, tab.content) : null;
  })));
};
Tabs.defaultProps = {
  selectedTab: 0,
  onTabChange: function onTabChange() {},
  className: ''
};
Tabs.propTypes = {
  /**
  Tabs content array
   */
  tabs: PropTypes.arrayOf(PropTypes.shape({
    title: nodeOrStringProp.isRequired,
    titleIcon: PropTypes.string,
    content: nodeOrStringProp.isRequired
  })).isRequired,
  /**
  Function triggered on tab change
   */
  onTabChange: PropTypes.func,
  /**
  Selected tab array position
   */
  selectedTab: PropTypes.number,
  /**
  Custom className
   */
  className: PropTypes.string
};

export default Tabs;
